import _ from 'lodash';
import { LocaleMessageObject } from 'vue-i18n';

import { I18nLangExport } from '@libs-uuif/assets/i18n/types';
import { lang as Lang } from '@libs-uuif/assets/i18n/locales/lib/en-US.lib-lang';
import { localStorageKeeperService } from '@/shared/auth-service';

import en from '../en.json';
import ja from '../ja.json';
import zh from '../zh.json';
import de from '../de.json';
import fr from '../fr.json';
import it from '../it.json';
import ko from '../ko.json';
import pt from '../pt.json';
import es from '../es.json';

// const localeInformation = (localStorage as any).getItem('currentLang');
const localeInformation = localStorageKeeperService.retrieve('currentLang');
console.warn(localeInformation);
let languageFile: any;

if (localeInformation && localeInformation.includes('en')) {
  languageFile = en;
} else if (localeInformation && localeInformation.includes('fr')) {
  languageFile = fr;
} else if (localeInformation && localeInformation.includes('it')) {
  languageFile = it;
} else if (localeInformation && localeInformation.includes('ko')) {
  languageFile = ko;
} else if (localeInformation && localeInformation.includes('de')) {
  languageFile = de;
} else if (localeInformation && localeInformation.includes('pt')) {
  languageFile = pt;
} else if (localeInformation && localeInformation.includes('zh')) {
  languageFile = zh;
} else if (localeInformation && localeInformation.includes('ja')) {
  languageFile = ja;
} else if (localeInformation && localeInformation.includes('es')) {
  languageFile = es;
} else {
  // FALLBACK CASE
  languageFile = en;
}

const appMessageObj: LocaleMessageObject = {
  ...languageFile,
  navService: {
    items: {
      unifiedInsights: 'Unified Insights',
      dashboard: 'Dashboard',
      reports: 'Reports',
    },
  },
};

const messageObj = _.merge({}, Lang.messageObj, appMessageObj);

export const lang = {
  messageObj,
  localeName: Lang.localeName,
} as I18nLangExport;
